/**
 * ============================================================================
 * DESCRIPTION CLIPPER COMPONENT
 * ============================================================================
 *
 * Handles "show more" / "show less" toggle for clippable product descriptions.
 * Uses a gradient overlay + expand/collapse with smooth CSS transition.
 *
 * ============================================================================
 */

class DescriptionClipper {
  constructor(element) {
    this.element = element;
    this.toggleBtn = element.querySelector('.description__clippable-toggle');
    this.cardWidget = element.closest('.card-widget--clippable');

    if (!this.toggleBtn || !this.cardWidget) return;

    this.expandedClass = 'card-widget--clippable--expanded';
    this._toggle = this.toggle.bind(this);
    this.init();
  }

  init() {
    this.toggleBtn.addEventListener('click', this._toggle);
  }

  toggle() {
    const isExpanded = this.cardWidget.classList.contains(this.expandedClass);

    if (isExpanded) {
      this.cardWidget.classList.remove(this.expandedClass);
      this.toggleBtn.setAttribute('aria-expanded', 'false');
    } else {
      this.cardWidget.classList.add(this.expandedClass);
      this.toggleBtn.setAttribute('aria-expanded', 'true');
    }
  }

  destroy() {
    if (this.toggleBtn) {
      this.toggleBtn.removeEventListener('click', this._toggle);
    }
  }
}

window.DescriptionClipper = DescriptionClipper;
